// إضافة دالة جلب بيانات الموظفين
export const fetchEmployees = async () => {
  const subdomain = window.location.hostname.split('.')[0];
  const apiUrl = `https://${subdomain}.restocash.app/api/get/employees/data?api_password=Project102$_`;

  const token = localStorage.getItem("token");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ Error fetching employees:", data);
      throw new Error(data?.message || "Failed to fetch employees");
    }

    console.log("✅ Employees data:", data.data);
    return data.data; // مصفوفة الموظفين
  } catch (error) {
    console.error("❌ Exception while fetching employees:", error);
    throw error;
  }
};

// إضافة دالة إنشاء موظف جديد (تستخدم form-data لدعم رفع الملفات مثل nationa_id)
export const addEmployee = async (employeeData = {}) => {
  const subdomain = window.location.hostname.split('.')[0];
  const url = `https://${subdomain}.restocash.app/api/add/employees/data?api_password=Project102$_`;
  const token = localStorage.getItem("token");

  try {
    const formData = new FormData();

    // إضافة الحقول إلى FormData. إذا كان القيمة ملفًا (File/Blob)، يتم إضافته كما هو.
    Object.entries(employeeData).forEach(([key, value]) => {
      if (value === undefined || value === null) return;

      // إذا كانت قيمة مصفوفة أو كائن بسيط يُراد إرساله كنص
      if (Array.isArray(value) || (typeof value === "object" && !(value instanceof File) && !(value instanceof Blob))) {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // لا تضف Content-Type عند استخدام FormData؛ المتصفح يعيّنها تلقائياً
      },
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ Error adding employee:", data);
      throw new Error(data?.message || "Failed to add employee");
    }

    console.log("✅ Add employee response:", data);
    return data;
  } catch (error) {
    console.error("❌ Exception while adding employee:", error);
    throw error;
  }
};

// إضافة دالة تعديل موظف (تستخدم form-data لدعم رفع الملفات مثل nationa_id)
export const editEmployee = async (id, employeeData = {}) => {
  if (id === undefined || id === null) {
    throw new Error("editEmployee: missing employee id");
  }
  const subdomain = window.location.hostname.split('.')[0];
  const url = `https://${subdomain}.restocash.app/api/edite/employee/data/${id}?api_password=Project102$_`;
  const token = localStorage.getItem("token");

  try {
    const formData = new FormData();

    // إضافة الحقول إلى FormData
    Object.entries(employeeData).forEach(([key, value]) => {
      if (value === undefined || value === null) return;

      if (Array.isArray(value) || (typeof value === "object" && !(value instanceof File) && !(value instanceof Blob))) {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // لا تضف Content-Type عند استخدام FormData
      },
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ Error editing employee:", data);
      throw new Error(data?.message || "Failed to edit employee");
    }

    console.log("✅ Edit employee response:", data);
    return data;
  } catch (error) {
    console.error("❌ Exception while editing employee:", error);
    throw error;
  }
};

// جلب موظف واحد حسب المعرف
export const fetchEmployeeById = async (id) => {
  if (id === undefined || id === null) {
    throw new Error("fetchEmployeeById: missing id");
  }
  const subdomain = window.location.hostname.split('.')[0];
  // افترض مسار API مناسب لطلب موظف واحد؛ عدِّل المسار إذا كان API يختلف
  const apiUrl = `https://${subdomain}.restocash.app/api/get/employee/info/${id}?api_password=Project102$_`;
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ Error fetching employee by id:", data);
      throw new Error(data?.message || "Failed to fetch employee");
    }

    // حاول إرجاع الكائن مباشرةً إن وُجد ضمن data.data أو data
    return data?.data ?? data;
  } catch (error) {
    console.error("❌ Exception while fetching employee by id:", error);
    throw error;
  }
};

// إضافة دالة لعمل معاملة مالية للموظف (تقبل form-data: date, orginal_amount, bouns, discount, total, action_type, employee_id, bank_id, note, file ...)
export const makeEmployeeTransaction = async (transactionData = {}) => {
  const subdomain = window.location.hostname.split('.')[0];
  const url = `https://${subdomain}.restocash.app/api/make/employee/transaction?api_password=Project102$_`;
  const token = localStorage.getItem("token");

  try {
    const formData = new FormData();

    Object.entries(transactionData).forEach(([key, value]) => {
      if (value === undefined || value === null) return;

      // إذا كان ملفًا أو Blob أرسله كما هو، وإذا كان كائنًا/مصفوفة فحوّله إلى JSON
      if (Array.isArray(value) || (typeof value === "object" && !(value instanceof File) && !(value instanceof Blob))) {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // لا تضف Content-Type عند استخدام FormData
      },
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ Error making employee transaction:", data);
      throw new Error(data?.message || "Failed to make employee transaction");
    }

    console.log("✅ Employee transaction response:", data);
    return data;
  } catch (error) {
    console.error("❌ Exception while making employee transaction:", error);
    throw error;
  }
};


